import { render, staticRenderFns } from "./EventRow.vue?vue&type=template&id=7b0b1490"
import script from "./EventRow.vue?vue&type=script&lang=js"
export * from "./EventRow.vue?vue&type=script&lang=js"
import style0 from "./EventRow.vue?vue&type=style&index=0&id=7b0b1490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports